"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTreeNodeDisplayName = void 0;
const react_1 = require("react");
const attributes_1 = require("../client/attributes");
const localization_1 = require("../../localization");
const treeNodeTitleToLocalizationKeyMap = {
    [attributes_1.ONTOLOGY_NODE_TITLE]: 'NO_SELECTED_STRATEGY_PLACEHOLDER',
    [attributes_1.UN_CATEGORIZED_NODE_TITLE]: 'UN_CATEGORIZED_NODE_TITLE',
};
const useTreeNodeDisplayName = () => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const getTreeNodeDisplayNameByTitle = (0, react_1.useCallback)((title) => {
        const messageKey = treeNodeTitleToLocalizationKeyMap[title];
        if (!messageKey) {
            return title;
        }
        return t({ key: messageKey });
    }, [t]);
    return {
        getTreeNodeDisplayNameByTitle,
    };
};
exports.useTreeNodeDisplayName = useTreeNodeDisplayName;
